import { createContext } from 'react';
import { PeriodType } from '@libs/types';

export const PeriodContext = createContext<PeriodType>({} as PeriodType);

export const PeriodProvider = PeriodContext.Provider;
